import { atom } from "recoil";
import { localStorageEffect } from "./localStorageEffect";

export type UnitSystem = "metric" | "imperial";

export const unitSystemAtom = atom<UnitSystem>({
  key: "unitSystem",
  default: "metric",
  effects_UNSTABLE: [localStorageEffect("unitSystem")],
});
